import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  computeAdminMrrStatsApi,
  getAdminMrrStatsApi,
} from "../api/adminMrrStatsApi";

export const ADMIN_MRR_STATS_QUERY_KEY = ["admin", "mrrStats"];

export const useGetAdminMrrStatsQuery = (fromDate: string, toDate: string) => {
  return useQuery({
    queryKey: [...ADMIN_MRR_STATS_QUERY_KEY, fromDate, toDate],
    queryFn: () => getAdminMrrStatsApi(fromDate, toDate),
  });
};

export const useComputeAdminMrrStatsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: computeAdminMrrStatsApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ADMIN_MRR_STATS_QUERY_KEY });
    },
  });
};
